import "./MicLoader.css";

type Props = {
  direction: "left" | "right";
};

function WaveGroup({ direction }: Props) {
  return (
    <div className={`wave-group ${direction}`}>
      {[1, 2, 3, 4].map((i) => (
        <span key={i} className={`wave wave-${i}`} />
      ))}
    </div>
  );
}

export default function MicLoader() {
  return (
    <div className="mic-loader">
      <div className="mic-row">
        <WaveGroup direction="left" />

        <img
          src="/assets/svg/Mic.svg"
          alt="Mic"
          className="mic-icon"
        />

        <WaveGroup direction="right" />
      </div>

      <p className="mic-text">Loading...</p>
    </div>
  );
}
